var _title, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "email")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.47,3.49H3.53a2,2,0,0,0-2,2v6.94a2,2,0,0,0,2,2H14.47a2,2,0,0,0,2-2V5.53A2,2,0,0,0,14.47,3.49Zm0,1a1,1,0,0,1,.57.2L9,9.43a.17.17,0,0,1-.21,0L2.87,4.77a1,1,0,0,1,.66-.26Zm0,9H3.53a1,1,0,0,1-1-1V5.8l5.66,4.44a1.18,1.18,0,0,0,1.48,0l5.84-4.57v6.8A1,1,0,0,1,14.47,13.49Z"
  })));
}

export default SvgEMail;